module.exports = __webpack_public_path__ + "img/pdf.c6d75405.svg";